export enum Role {
  SalesAdmin = 'Sales.Admin',
  SalesManager = 'Sales.Manager',
  SalesConciliator = 'Sales.Conciliator',
  SalesObserver = 'Sales.Observer'
}
